import React, {useState} from 'react'
import {Button, Form, Input, InputNumber, message, Modal, Switch, TimePicker} from "antd"
import {PlusOutlined} from "@ant-design/icons"
import moment from "moment"
import {addGrouponInfo} from "../../../api/groupon"
import {useGroupBuyingContext} from "../store/useGroupBuyingContext"
import {fixMinuteToSecond, fixYuanToFen} from "../../../util"


const GroupBuyingAdd = () => {
    const {grouponListState} = useGroupBuyingContext()

    const [isShow, setIsShow] = useState(false)
    const [isLoading, setIsLoading] = useState(false)
    const [isLimitTime, setIsLimitTime] = useState(false)

    const [form] = Form.useForm()

    const handleClick = () => {
        setIsShow(true)
    }

    const handleFinish = async () => {
        setIsLoading(true)

        const limitStartTime = form.getFieldValue('limitStartTime')
        const limitEndTime = form.getFieldValue('limitEndTime')
        const data = {
            groupon: {
                clubId: sessionStorage.getItem('club_id'),
                amount: fixYuanToFen(form.getFieldValue('amount')),
                duration: fixMinuteToSecond(form.getFieldValue('duration')),
                name: form.getFieldValue('name'),
            },
            limitTime: {
                isLimitTime: form.getFieldValue('isLimitTime'),
                startTime: limitStartTime ? limitStartTime.format('HH:mm:ss') : undefined,
                endTime: limitEndTime ? limitEndTime.format('HH:mm:ss') : undefined,
            },
            gifts: []
        }
        await addGrouponInfo(data).then((res) => {
            if (res.status !== 1) {
                message.error(`更新团购信息失败：${res.detail}`)
                return
            }
            message.success('更新成功')
            setIsShow(false)
            grouponListState.reFetch()
        }).catch(err => {
            message.error(`更新失败：${err.message}`)
        }).finally(() => {
            setIsLoading(false)
        })
    }

    return (
        <div>
            <Button onClick={handleClick} icon={<PlusOutlined/>} type={"primary"}>新增团购</Button>
            <Modal
                open={isShow}
                onCancel={() => setIsShow(false)}
                onOk={form.submit}
                confirmLoading={isLoading}
            >
                <Form
                    style={{padding: "20px"}}
                    labelCol={{span: 6}}
                    wrapperCol={{span: 18}}
                    form={form}
                    onFinish={handleFinish}
                >
                    <Form.Item
                        label="团购名称"
                        name="name"
                        rules={[{required: true, message: '请输入团购名称'}]}
                    >
                        <Input/>
                    </Form.Item>
                    <Form.Item
                        label="价格"
                        name="amount"
                        rules={[{required: true, message: '请输入价格'}]}
                    >
                        <InputNumber addonAfter={"元"} style={{width: '100%'}}/>
                    </Form.Item>
                    <Form.Item
                        label="时长"
                        name="duration"
                        rules={[{required: true, message: '请输入时长'}]}
                    >
                        <InputNumber addonAfter={"分钟"} style={{width: '100%'}}/>
                    </Form.Item>
                    <Form.Item
                        label="限时段核销"
                        name="isLimitTime"
                        valuePropName="checked"
                    >
                        <Switch onChange={(checked) => setIsLimitTime(checked)}/>
                    </Form.Item>
                    {isLimitTime && (
                        <div>
                            <Form.Item
                                label="可用开始时间"
                                name="limitStartTime"
                                rules={[{required: true, message: '请选择可用开始时间'}]}
                            >
                                <TimePicker format="HH:mm" style={{width: '100%'}}/>
                            </Form.Item>
                            <Form.Item
                                label="可用结束时间"
                                name="limitEndTime"
                                rules={[{required: true, message: '请选择可用结束时间'}]}
                            >
                                <TimePicker format="HH:mm" style={{width: '100%'}}/>
                            </Form.Item>
                        </div>
                    )}
                </Form>
            </Modal>
        </div>
    )

}

export default GroupBuyingAdd



// WEBPACK FOOTER //
// ./src/containers/GroupBuyingList/components/GroupBuyingAdd.js